<template>
	<button
		class="dropdown-list_item"
		:class="{'dropdown-list_item--active': isActive}"
		:disabled="option.disabled"
		type="button"
		@click.stop="onSelect"
		@blur="onBlur"
		@focus="onFocus"
		@keydown="keyDown"
		ref="btn"
	>
		{{ label }}
		<base-icon v-if="hasChildren" icon-name="down" />
	</button>
</template>

<script>
export default {
	name: 'DropdownCustomListBtn',
	inject: ['selectOption', 'reactiveInject', 'keyController'],
	props: {
		option: {
			type: Object,
			default: function () {
				return null;
			},
		},
	},
	computed: {
		label() {
			return this.option?.value?.enUS ?? '';
		},
		isActive() {
			const {selectedOption, parentSelectedOption, autoShowSelected} = this.reactiveInject;
			return (
				(this.option?.key === selectedOption?.key && autoShowSelected) ||
				this.option?.key === parentSelectedOption?.key
			);
		},
		hasChildren() {
			return this.option.children.length;
		},
	},
	watch: {
		'option.focus': {
			handler(newFocus) {
				if (newFocus) this.focus();
			},
			immediate: true,
		},
	},
	methods: {
		keyDown(e) {
			if (e.key === 'Enter') e.preventDefault();
			if (e.key === 'Enter' && !this.hasChildren) this.onSelect();
			else this.keyController(e);
		},
		focus() {
			const btn = this.$refs.btn;
			if (btn) this.$refs.btn.focus();
			else this.$nextTick(() => this.$refs.btn.focus());
		},
		onBlur() {
			this.option.focus = false;
		},
		onFocus() {
			this.option.focus = true;
		},
		onSelect() {
			this.selectOption({...this.option});
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
.dropdown-list_item {
	@include font-styles('Futura W01 Book', 400);
	font-size: 16px;
	white-space: pre-line;
	margin: 0;
	padding: 3px 12px 3px 20px;
	width: 100%;
	min-height: 48px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	text-align: left;
	color: $color-text-grey;
	border: none;
	background-color: transparent;
	transition: background-color 0.3s;
	.icons {
		font-size: 19px;
		@media (min-width: $mobile) {
			transform: rotateZ(-90deg);
		}
	}
	&.dropdown-list_item--active,
	&:hover,
	&:focus {
		background-color: $color-super-light-blue;
	}
	&:disabled {
		color: $color-grey-5;
		background-color: inherit;
	}
}
.dropdown-list_item--active {
	.icons {
		transform: rotateZ(180deg);
		@media (min-width: $mobile) {
			transform: rotateZ(-90deg);
		}
	}
}
.dropdown-list_item {
	::v-deep {
		.dropdown_list--child & {
			padding-left: 32px;
			font-size: 14px;
		}
	}
}
</style>
